
import Decred from "../../../assets/duotone/Decred.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DecredIcon({ className, dataTestid = "DecredIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Decred data-testid={dataTestid} className={classes} {...rest} />
  );
}
